import { da } from "element-plus/es/locale/index.mjs";
import { getUserId } from "~/common/helpers";
import PublisherService from "~/services/PublisherService";
import { usePublisherStore } from "~/store/PublisherModule";
import { getApiErrorMessage } from "~/common/API/apiErrors";

interface IPublisherOrdersState {
  orders: any[];
}

export const usePublisherOrdersStore = defineStore("publisherorders", () => {

  const publisherStore = usePublisherStore();

  const orders = ref<any[]>([]);
  const publicationCount = ref<{
    total: number;
    "admin-rejected"?: number;
    "admin-approved"?: number;
    cancel?: number;
    new: number;
    archived: number;
  }>({
    total: 0,
    new: 0,
    "admin-rejected": 0,
    "admin-approved": 0,
    cancel: 0,
    archived: 0,
  });

  // const getPublisherOrders = async (params: any) => {
  //   return true;
  // }
  interface IParams {
    "status[]"?: any[];
    status?: string;
    tab?: number;
    placeId?: number | string;
    period?: string[] | null;
    createdAtFrom?: number | string;
    createdAtTo?: number | string;
    text?: string;
    publisherId?: number;
    pageNumber?: number;
    isArchivedByPublisher?: number;
  }
  const getPublisherOrders = async (params: IParams) => {
    // console.log("params1", params);
    // return;
    if (params) {
      Object.keys(params).forEach((key: any) => {
        const value = params[key as keyof IParams];
        if (value === null || (typeof value === "string" && value === "")) {
          delete params[key as keyof IParams];
          return;
        }
        if (key === "status[]" && Array.isArray(value) && value[0] === "all") {
          delete params[key as keyof IParams];
          return;
        }
        if (key === "placeId" && String(params[key as keyof IParams]) === "all") {
          delete params[key as keyof IParams];
          return;
        }
        if (key === "period" && params[key as keyof IParams]) {
          const period = params[key as keyof IParams];
          if (Array.isArray(period) && period.length >= 2) {
            params["createdAtFrom"] = period[0]
              ? new Date(period[0]).toISOString().split("T")[0]
              : "";
            params["createdAtTo"] = period[1]
              ? new Date(new Date(period[1]).getTime() + 24 * 60 * 60 * 1000)
                .toISOString()
                .split("T")[0]
              : "";
            delete params[key as keyof IParams];
          }
          return;
        }
      });
    }
    // console.log("params2", params);
    if (params && params.tab) {
      switch (params.tab) {
        case 1:
          params["status[]"] = ["admin-approved"];
          break;
        case 2:
          params["status[]"] = ["publisher-approved", "advertiser-link-rejected"];
          break;
        case 3:
          params["status[]"] = ["link-provided"];
          break;
        case 4:
          params["status[]"] = ["advertiser-link-approved", "advertiser-timeout"];
          break;
        case 5:
          params["status[]"] = [
            "publisher-rejected",
            "publisher-set-link-timeout",
            "cancel",
            "publisher-decision-timeout",
          ];
          break;
        case 6:
          console.log("archive");
          params["isArchivedByPublisher"] = 1;
          break;
        case 100:
        default:
          delete params.tab;
      }
    }
    if (!params) {
      params = {};
    }
    if (!params["status[]"]) {
      params["status[]"] = [
        "admin-approved",
        "publisher-approved",
        "link-provided",
        "advertiser-link-approved",
        "advertiser-link-rejected",
        "publisher-rejected",
        "advertiser-timeout",
        "publisher-set-link-timeout",
        "cancel",
        "publisher-decision-timeout",
      ];
    }
    // console.log('params2', params, publisherStore.id);

    if (!params["isArchivedByPublisher"]) {
      params["isArchivedByPublisher"] = 0;
    }

    let pubId = params["publisherId"] || publisherStore.id;
    if (!pubId || pubId === 0) {
      pubId = getUserId() || 0;
    }
    try {
      orders.value = [];
      const result = await PublisherService.getPublisherOrders({
        ...params,
        publisherId: +pubId,
        "sortFields[]": "id",
        "sortDirections[]": "desc",
      });
      if (result) {
        await getPublicationCount(+pubId);
        return result;
      } else {
        throw new Error("Не удалось получить заказы");
      }
      return result;
    } catch (error) {
      //console.error('Ошибка при получении заказов:', error);
      return [];
    }
  };

  const getPublicationCount = async (id: number) => {
    let idQuery = id;
    if (!id) idQuery = +publisherStore.id;

    const result: any = await PublisherService.getPublicationCount(idQuery);
    if (result) {
      const newCount = {
        new: 0,
        cancel: 0,
        inprogress: 0,
        done: 0,
        success: 0,
        archived: 0,
      };
      result.publicationsCount.map((item: any) => {
        item.count.map((x: any) => {
          newCount.new += x["admin-approved"] ?? 0;
          newCount.cancel += x["publisher-rejected"] ?? 0;
          newCount.cancel += x["publisher-set-link-timeout"] ?? 0;
          newCount.cancel += x["cancel"] ?? 0;
          newCount.cancel += x["publisher-decision-timeout"] ?? 0;
          newCount.inprogress += x["publisher-approved"] ?? 0;
          newCount.inprogress += x["advertiser-link-rejected"] ?? 0;
          newCount.done += x["link-provided"] ?? 0;
          newCount.success += x["advertiser-link-approved"] ?? 0;
          newCount.success += x["advertiser-timeout"] ?? 0;
          newCount.archived += x["archived"] ?? 0;
        });
      });
      let total = 0;
      Object.keys(newCount).forEach((key: string) => {
        if (key !== "archived") {
          total += newCount[key as keyof typeof newCount] ?? 0;
        }
      });

      publicationCount.value = { ...newCount, total };
    }
  };

  const getPlacePublicationCount = async (placeId: number) => {
    console.log("placeId", placeId);
    if (!placeId) return;
    let newCount = {
      new: 0,
      cancel: 0,
      inprogress: 0,
      done: 0,
      success: 0,
      total: 0,
      archived: 0,
    };
    const result: any = await PublisherService.getPublicationCount(+publisherStore.id);
    if (result) {
      console.log("result", result);
      result.publicationsCount.map((item: any) => {
        if (item.placeId === placeId) {
          item.count.map((x: any) => {
            newCount.new += x["admin-approved"] ?? 0;
            newCount.cancel += x["publisher-rejected"] ?? 0;
            newCount.cancel += x["publisher-set-link-timeout"] ?? 0;
            newCount.cancel += x["publisher-decision-timeout"] ?? 0;
            newCount.inprogress += x["publisher-approved"] ?? 0;
            newCount.inprogress += x["advertiser-link-rejected"] ?? 0;
            newCount.done += x["link-provided"] ?? 0;
            newCount.success += x["advertiser-link-approved"] ?? 0;
            newCount.success += x["advertiser-timeout"] ?? 0;
            newCount.archived += x["archived"] ?? 0;
          });
        }
      });

      Object.keys(newCount).forEach((key: string) => {
        if (key !== "total") {
          newCount.total += newCount[key as keyof typeof newCount] ?? 0;
        }
      });
    }
    return newCount;
  };

  const orderReject = async (data: { id: number; reason: string }) => {
    try {
      const res = await PublisherService.orderReject(data);
      console.log(res);
      ElNotification({
        title: "Успешное отклонение",
        type: "success",
      });
    } catch (err) {
      console.log(err);
    }
  };

  const orderApprove = async (data: {
    publicationDateTime: string;
    comment?: string;
    id: number;
  }) => {
    try {
      const res: any = await PublisherService.orderApprove(data);
      // res мог прийти undefined — тогда res.error бросал TypeError,
      // и пользователь не видел вообще ничего.
      if (res?.error) {
        ElNotification({
          title: "Ошибка даты!",
          type: "error",
        });
        return null;
      }
      ElNotification({
        title: "Успешно!",
        type: "success",
      });
      return res;
    } catch (err: any) {
      console.log(err);
      // Ошибки бэка показываем понятным текстом: 1595 — публикацию уже взяли в работу.
      ElNotification({
        title: getApiErrorMessage(err, "Не удалось взять заказ в работу"),
        type: "error",
      });
      // null, а не { error }: иначе confirmModerate подсветит поле даты как неверное,
      // хотя проблема не в дате.
      return null;
    }
  };

  const sendLink = async (payload: { url: string; id: number }) => {
    try {
      const res = await PublisherService.sendLink(payload);
      if (res) {
        ElNotification({
          title: "Успешно!",
          type: "success",
        });
        return res;
      }
      ElNotification({
        title: "Ошибка отправки ссылки!",
        type: "error",
      });
    } catch (err) {
      console.error(err);
      ElNotification({
        title: "Ошибка отправки ссылки!",
        type: "error",
      });
    }
  };

  const orderCancel = async (payload: { id: number; reason: string }) => {
    try {
      const res = await PublisherService.orderCancel(payload);
      console.log(res);
      ElNotification({
        title: "Успешное завершение заказа",
        type: "success",
      });
    } catch (err) {
      console.log(err);
    }
  };

  return {
    orders,
    publicationCount,
    getPublisherOrders,
    getPublicationCount,
    getPlacePublicationCount,
    orderReject,
    orderApprove,
    sendLink,
    orderCancel,
  };
});
